import CssBaseline from "@mui/material/CssBaseline";
import { LinearProgressLoader } from "components/Loaders";
import { SnackbarOnError } from "components-redesign/Snackbar";
import InlinePageWarning from "components/Notifications/InlinePageWarning";
import { makeStyles } from "components/mui-core";
import { authSlice, useOrgSwitchError } from "redux/auth";
import { useAccountId, useOrganizationId } from "redux/auth/selectors";
import useServiceUnavailable, {
  SERVICE_UNAVAILABLE_WARNING,
} from "redux/auth/useServiceUnavailable";
import { useAppDispatch } from "redux/store";
import TabContent from "../TabContent/TabContent";
import NavigationMenu from "./NavigationMenu/NavigationMenu";

const useStyles = makeStyles()({
  root: {
    display: "flex",
  },
});

function Layout({ navigationMenuItems, rootPath, children }) {
  const { classes } = useStyles();
  const organizationId = useOrganizationId();
  const accountId = useAccountId();
  const orgSwitchError = useOrgSwitchError();
  const dispatch = useAppDispatch();

  const [isServiceUnavailable] = useServiceUnavailable();

  return (
    <div className={classes.root}>
      <CssBaseline />
      <NavigationMenu
        menuItems={navigationMenuItems}
        rootPath={rootPath}
      />
      <TabContent isExpanded={!open}>
        {isServiceUnavailable && (
          <InlinePageWarning text={SERVICE_UNAVAILABLE_WARNING} />
        )}
        {orgSwitchError && (
          <SnackbarOnError
            isOpen
            // Persistent: leaves the user on the wrong organization.
            duration={false}
            message={orgSwitchError}
            onClose={() => {
              dispatch(authSlice.actions.setOrgSwitchError(""));
            }}
          />
        )}
        {organizationId && accountId ? children : <LinearProgressLoader />}
      </TabContent>
    </div>
  );
}

export default Layout;
